import rootReducerToolkit from '../reducersToolkit';
import accessLog from './accessLog/reducer';
import accessSettings from './accessSettings/reducer';
import { apartmentAdminReducers } from './apartmentAdmin/reducer';
import apartments from './apartments/reducer';
import { authReducers } from './auth/reducer';
import billing from './billing/reducer';
import common from './common/reducer';
import company from './company/reducer';
import cookieSettings from './cookies/reducer';
import devices from './devices/reducer';
import { elevatorIntegrationReducers } from './elevatorIntegration/reducer';
import { infrastructureReducers } from './infrastructure/reducer';
import { localizationReducers } from './localization/reducer';
import notifications from './notifications/reducer';
import payments from './payments/reducer';
import phonebooks from './phonebooks/reducer';
import sites from './sites/reducer';
import subscription from './subscription/reducer';
import user from './user/reducer';

export function getAllReducers() {
  return {
    ...rootReducerToolkit,
    accessLog,
    accessSettings,
    apartmentAdmin: apartmentAdminReducers,
    apartments,
    auth: authReducers,
    billing,
    common,
    company,
    cookieSettings,
    devices,
    elevatorIntegration: elevatorIntegrationReducers,
    infrastructure: infrastructureReducers,
    localization: localizationReducers,
    notifications,
    payments,
    phonebooks,
    sites,
    subscription,
    user,
  };
}
